import React from "react";
import "./css/Slideshow.css";
import Slide1 from "./Images/cover3.png"
import Slide2 from "./Images/header3.jpeg"
import Slide3 from "./Images/header4.png"
import "bootstrap/dist/css/bootstrap.css";


function Slideshow() {
  return (
    <div id="carouselExampleCaptions" className="carousel slide carousel-fade" data-bs-ride="carousel">
      <div className="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active"
          aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1"
          aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2"
          aria-label="Slide 3"></button>
      </div>
      <div className="carousel-inner" id="home">
        <div className="carousel-item active">
          <img src={Slide1} className="d-block w-100 head-img" alt="..." />
        </div>
        <div className="carousel-item">
          <img src={Slide2} className="d-block w-100 head-img head-img-2" alt="..." />
          <div className="carousel-caption d-none d-md-block header-2-text">
            <h2>Your Most Reliable Newsletter</h2>
            <p>Latest Updates | Newsletter | Trusted</p>
          </div>
        </div>
        <div className="carousel-item">
          <img src={Slide3} className="d-block w-100 head-img" alt="..." />
          <div className="carousel-caption d-none d-md-block header-3-text">
            <h2>Customized To Your Comfort</h2>
          </div>
        </div>
      </div>
      <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions"
        data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions"
        data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden" id="all-editions">Next</span>
      </button>
    </div>
  );
}

export default Slideshow;